"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRemindMeStatus = exports.getRemindMeStatus = exports.setLikedEventStatus = exports.getLikedEventStatus = exports.setFollowOrganizerStatus = exports.getFollowOrganizerStatus = void 0;

var _http = require("js-utils/http");

// See here all the possible email names
// https://github.com/eventbrite/core/blob/master/django/src/www/eventbrite/ebapps/email/__init__.py#L281
var LIKED_EVENT_REMINDERS_EMAIL = 'liked_event_reminders_email';
var NOTIFY_ORGANIZER_FOLLOWER_ON_PUBLISH_EMAIL = 'notify_organizer_follower_on_publish_email';
var REMIND_ME_EMAIL = 'remind_me_email';
var emailToEmailName = {
  remind_me: REMIND_ME_EMAIL,
  liked_event: LIKED_EVENT_REMINDERS_EMAIL,
  organizer_follow: NOTIFY_ORGANIZER_FOLLOWER_ON_PUBLISH_EMAIL
};

var emailPreferencesRootURL = function emailPreferencesRootURL(userId) {
  return "/api/v3/user/".concat(userId, "/email_preferences/");
};

var emailPreferenceGetURL = function emailPreferenceGetURL(email, userId) {
  return "".concat(emailPreferencesRootURL(userId), "?email_names=").concat(emailToEmailName[email]);
}; // Follow Organizer Email


var getFollowOrganizerStatus = function getFollowOrganizerStatus(userId) {
  return (0, _http.sdkRequest)(emailPreferenceGetURL('organizer_follow', userId));
};

exports.getFollowOrganizerStatus = getFollowOrganizerStatus;

var setFollowOrganizerStatus = function setFollowOrganizerStatus(userId, newState) {
  return (0, _http.sdkRequest)(emailPreferencesRootURL(userId), {
    method: 'POST',
    body: JSON.stringify({
      email_name: emailToEmailName['organizer_follow'],
      can_send: !!newState
    })
  });
}; // Liked Events Reminder Email


exports.setFollowOrganizerStatus = setFollowOrganizerStatus;

var getLikedEventStatus = function getLikedEventStatus(userId) {
  return (0, _http.sdkRequest)(emailPreferenceGetURL('liked_event', userId));
};

exports.getLikedEventStatus = getLikedEventStatus;

var setLikedEventStatus = function setLikedEventStatus(userId, newState) {
  return (0, _http.sdkRequest)(emailPreferencesRootURL(userId), {
    method: 'POST',
    body: JSON.stringify({
      email_name: emailToEmailName['liked_event'],
      can_send: !!newState
    })
  });
}; // Remind Me Email


exports.setLikedEventStatus = setLikedEventStatus;

var getRemindMeStatus = function getRemindMeStatus(userId) {
  return (0, _http.sdkRequest)(emailPreferenceGetURL('remind_me', userId));
};

exports.getRemindMeStatus = getRemindMeStatus;

var setRemindMeStatus = function setRemindMeStatus(userId, newState) {
  return (0, _http.sdkRequest)(emailPreferencesRootURL(userId), {
    method: 'POST',
    body: JSON.stringify({
      email_name: emailToEmailName['remind_me'],
      can_send: !!newState
    })
  });
};

exports.setRemindMeStatus = setRemindMeStatus;
//# sourceMappingURL=userEmailPreferences.js.map